import accountSvg from 'assets/image/icons/svg/account.svg'
import { AccountProfile } from 'components/molecules/account/accountProfile.tsx'
import { WorkingHoursProfile } from 'components/molecules/account/workingHoursProfile/index.tsx'
import { HomeTemplate } from 'components/templates/homeTemplate'
import { useEffect } from 'react'
import { leftSideHooks, useActionCreators } from 'shared/hooks'

import { appActions } from '../../redux/reducers/app.ts'
import css from './AccountPage.module.scss'

const leftSide: leftSideHooks.LeftSideInput = {
	bottomList: [
		{
			id: 1,
			image: accountSvg,
			link: '/account',
			title: 'Snaily account'
		}
	],
	type: 'account'
}

function AccountPage() {
	const { changePage } = useActionCreators(appActions)

	leftSideHooks.useLeft(leftSide)

	useEffect(() => {
		changePage('/account')
	}, [changePage])

	return (
		<HomeTemplate>
			<div className={css.root}>
				<AccountProfile />
				<WorkingHoursProfile />
			</div>
		</HomeTemplate>
	)
}

export default AccountPage
